import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../../helpers/ApiHelper";

export const uploadImage = createAsyncThunk(
  "notification/uploadImage",
  async (file, { rejectWithValue }) => {
    try {

      const formData = new FormData();
      formData.append("imageFile", file);

      const apiClient = new APIClient();
      const response = await apiClient.post(
        "/api/v1/clients/notification/campaigns/images",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      
      return response.data;
    } catch (error) {
      console.error("Upload failed:", error);
      if (error.response) {
        console.error("Error response:", error.response);
      }
      return rejectWithValue(error.response?.data || error.message || error);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  uploadedImage: null,
};

const uploadImageSlice = createSlice({
  name: "uploadImage",
  initialState,
  reducers: {
    resetUploadImage: (state) => {
      state.loading = false;
      state.error = null;
      state.uploadedImage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadImage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadImage.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.uploadedImage = action.payload;
      })
      .addCase(uploadImage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { resetUploadImage } = uploadImageSlice.actions;
export default uploadImageSlice.reducer; 